module.exports = __webpack_public_path__ + "static/media/kernelcon_hilton2.eeebbfb8.jpg";